import DiscussionMergedNotification from './DiscussionMergedNotification';
import DiscussionMergeModal from './DiscussionMergeModal';
import DiscussionMergePost from './DiscussionMergePost';
import DiscussionSearch from './DiscussionSearch';
import DiscussionSearchSource from './DiscussionSearchSource';

export const components = {
  DiscussionMergedNotification,
  DiscussionMergeModal,
  DiscussionMergePost,
  DiscussionSearch,
  DiscussionSearchSource,
};
